import * as bibleTypes from './types';
import * as bibleActions from './actions';
import { bibleReducer } from './reducers';

const { INIT_BIBLE } = bibleTypes;

export { bibleTypes, bibleActions, bibleReducer, INIT_BIBLE };
